import React from "react"
import { Link, graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"
import Layout from "../components/layout"

const Polyarch = () => {
  const data = useStaticQuery(graphql`
  query {
    imageOne: file(relativePath: { eq: "projects/gallery/PolyFrame_01.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    imageTwo: file(relativePath: { eq: "projects/gallery/PolyFrame_02.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  imageThree: file(relativePath: { eq: "projects/gallery/PolyFrame_03.jpg" }) {
    childImageSharp {
      fluid(maxWidth: 1000) {
        ...GatsbyImageSharpFluid
      }
    }
  }
  imageFour: file(relativePath: { eq: "projects/gallery/PolyFrame_04.jpg" }) {
    childImageSharp {
      fluid(maxWidth: 1000) {
        ...GatsbyImageSharpFluid
      }
    }
  }
  imageFive: file(relativePath: { eq: "projects/gallery/PolyFrame_05.jpg" }) {
    childImageSharp {
      fluid(maxWidth: 1000) {
        ...GatsbyImageSharpFluid
      }
    }
  }
  imageSix: file(relativePath: { eq: "projects/gallery/PolyFrame_06.jpg" }) {
    childImageSharp {
      fluid(maxWidth: 1000) {
        ...GatsbyImageSharpFluid
      }
    }
  }
  imageSeven: file(relativePath: { eq: "projects/gallery/PolyFrame_07.jpg" }) {
    childImageSharp {
      fluid(maxWidth: 1000) {
        ...GatsbyImageSharpFluid
      }
    }
  }
 
  }
  `)
  return (
    <Layout>
      <section class="body_center">
      <Img fluid={data.imageOne.childImageSharp.fluid} />
        <p class="legend">PolyArch Research_002. 2015</p>
        <div>
          <h1 class="mainTitle">PolyArch</h1>
        </div>
        <p>
          PolyArch is a personal research project that started off with a simple
          question; what is a 3D mesh? Greetings{" "}
          <a href="http://www.wblut.com/he_mesh/">
            Hemesh, a beautiful library
          </a>{" "}
          for Processing that enables you to generate 3D geometric form. The
          intricacies of programming the third dimension are well worth the
          effort, if only like me you eventually come back to 2D with more
          confidence. You learn a lot about geometry and as Frieder Nake once
          said to me, <i>"geometry is heaven, graphics is hell".</i> I'm not in
          total agreement but I always love that quote. Here are some examples
          of the fruit of that research into the realm of polygons. I called it
          PolyArch because I'm intrigued too by architecture. Additional
          raytracing was rendered with{" "}
          <a href="http://sunflow.sourceforge.net/">SunFlow.</a>
        </p>

        <p class="notes">
          Project type : Formal research
          <br />
          Tools used : Processing, Hemesh, Java SunFlow
          <br />
          Code Repository :{" "}
          <a href="https://bitbucket.org/mwebster_/he_mesh/src/master/">
            Hemesh tutorial
          </a>
        </p>
      </section>

      <section class="body_wide">
      <Img fluid={data.imageFour.childImageSharp.fluid} />
        <p class="legend">PolyArch Research_003. 2015</p>
      </section>


      <section class="body_center">
      <Img fluid={data.imageThree.childImageSharp.fluid} />
        <p class="legend">PolyArch Research_005. 2015</p>
      </section>

      <section class="body_center">
        <p>
          I love music, I play the piano and have dabbled in many an electronic
          laptop adventure. It has always been my dream to work with musicians
          and on the visual side. There is comfort in working with sound and
          there is even more comfort in working for a fixed format - that of the
          perennial album cover. I had the rare occasion to design the artwork
          for a French contemporary jazz setup based in Paris. My PolyArch
          experiments were used for their album, <i>Silent Form.</i> I'd love to
          pursue with more...
        </p>
      </section>

      <section class="body_center">
      <Img fluid={data.imageSeven.childImageSharp.fluid} />
        <p class="legend">Silent Form CD Cover. 2015</p>
      </section>

      <section class="body_center">
      <Img fluid={data.imageFive.childImageSharp.fluid} />
        <p class="legend">PolyArch Research_010. 2015</p>
      </section>

      <section class="body_wide">
      <Img fluid={data.imageTwo.childImageSharp.fluid} />
        <p class="legend">PolyArch Research_012. 2015</p>
      </section>

      <section class="body_center">
      <Img fluid={data.imageSix.childImageSharp.fluid} />
        <p class="legend">PolyArch Research_014. 2015</p>
      </section>

  
    </Layout>
  )
}

export default Polyarch
